import { Button, IButtonProps } from "ui/gluestack/button";
import { Icon } from "ui/gluestack/icon";
import { LogoutIcon } from "ui/gluestack/icon/Logout";
import { Text } from "react-native";

export const LogoutButton = (props: IButtonProps) => {
  return (
    <Button {...props} variant="link" className="justify-start">
      <Icon as={LogoutIcon} className="stroke-error-500" />
      <Text className="font-base text-typography-900">Logout</Text>
    </Button>
  );
};
